import { Loader } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useAuthCompat } from "../hooks/useAuthCompat";

export const Route = createFileRoute("/signup")({
	component: SignUpRedirect,
});

function SignUpRedirect() {
	const { user, isLoading, signUp } = useAuthCompat();

	useEffect(() => {
		if (isLoading) return;
		if (user) {
			window.location.href = "/";
			return;
		}
		signUp();
	}, [user, isLoading, signUp]);

	return (
		<div className="flex items-center justify-center min-h-screen">
			<Loader size="lg" />
		</div>
	);
}
